import React, { forwardRef } from 'react'
import './Card.css'

const Card = forwardRef(({ className, children, ...rest }, ref) => {
  return (
    <div ref={ref} className={`cards ${className ?? ''}`} {...rest}>{children}</div>
  )
})

export default Card